import { render, staticRenderFns } from "./addAgent2.vue?vue&type=template&id=0ddfde18&scoped=true&"
import script from "./addAgent2.vue?vue&type=script&lang=js&"
export * from "./addAgent2.vue?vue&type=script&lang=js&"
import style0 from "./addAgent2.vue?vue&type=style&index=0&id=0ddfde18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfde18",
  null
  
)

export default component.exports